import React from "react"
import axios from 'axios'

function pageRender() {
         setTimeout(() => {
          try {
            document.getElementById("devPageContent").style.opacity = 1
            document.getElementById("devPageContent").style.visibility = "visible"
          }
          catch { }
        }, 50) 
  }

const DevPage = () => {
    pageRender()
    return <div className="loginPage" id="devPageContent" style={{ textAlign: "center", paddingTop: "64px", opacity: "0", visibility: "hidden", transition: ".3s opacity, .3s visibility" }}>
        <h3 style={{ color: "#E0E0E0", fontSize: 25 }}>
            <i className="fas fa-code fa-lg" style={{ color: "#E0E0E0", fontSize: 150, marginBottom: "25px" }}></i>
            <br /><br />Раздел в активной разработке</h3>
    </div>
}

export default DevPage